import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { setAlert } from '../../actions/alert';
import { buscarAsesorados, buscarAsesores, buscarAsesoriasCita } from '../../actions/psicologica';

const FiltrosAsesorias = ({ busqueda, reestablecerFiltros }) => {

    const dispatch =  useDispatch();

    const { listado_asesorias_cita, listado_asesores } = useSelector(state => state.psicologica);

    const [nuevoModal, setNuevoModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [busquedaData, setBusquedaData] = useState({
        fecha_inicio: new Date(),
        fecha_fin: new Date(),
        mensajes: null, 
        id_joven: null,
        id_asesor: null, 
        status: [null, 0, 1, 2], 
        busqueda: false
    });

    const [mensajesData, setMensajesData] = useState(null);
    const mensajesFilter = [
        { value: false, label: 'Sin mensajes' }, 
        { value: true, label: 'Con mensajes' }
    ];

    const [jovenData, setJovenData] = useState(null);
    const [jovenesFilter, setJovenesFilter] = useState([]);

    const [asesorData, setAsesorData] = useState(null);
    const [asesoresFilter, setAsesoresFilter] = useState([]);

    const [statusData, setStatusData] = useState([
        { value: null, label: 'Sin cita' }, 
        { value: 0, label: 'Pendiente' }, 
        { value: 1, label: 'Aprobada' }, 
        { value: 2, label: 'Rechazada' }
    ]);
    const statusFilter = [
        { value: null, label: 'Sin cita' }, 
        { value: 0, label: 'Pendiente' }, 
        { value: 1, label: 'Aprobada' }, 
        { value: 2, label: 'Rechazada' }
    ];

    /* Buscar */
    const handleAbrir = () => {
        dispatch(buscarAsesoriasCita());
        dispatch(buscarAsesores());
    }

    const handleDatePicker = (name, value) => {
        setBusquedaData({
            ...busquedaData,
            [name]: value
        });
    }

    const handleSelectMensajes = (option) => {
        setMensajesData(option);

        setBusquedaData({
            ...busquedaData,
            mensajes: option != null ? option.value : null
        });
    }

    const handleSelectJoven = (option) => {
        setJovenData(option);

        setBusquedaData({
            ...busquedaData,
            id_joven: option != null ? option.value : null
        });
    }

    const handleSelectAsesor = (option) => {
        setAsesorData(option);

        setBusquedaData({
            ...busquedaData,
            id_asesor: option != null ? option.value : null
        });
    }

    const handleSelectStatus = (option) => {
        setStatusData(option);

        let status = [];

        for (var i = 0; i < option?.length; i++) {
            status.push(option[i].value);
        }

        setBusquedaData({
            ...busquedaData,
            status
        });
    }
    
    const handleProcesar = async () => {
        if(new Date(busquedaData.fecha_inicio) <= new Date(busquedaData.fecha_fin)){
            await setStatusProcesar(true);
            await dispatch(buscarAsesorados(busquedaData));
            await handleCerrar();
            await setStatusProcesar(false);
        }else{
            await dispatch(setAlert('Tu fecha de inicio es mayor a tu fecha de finalización', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setNuevoModal(false);
            reestablecerFiltros({
                ...busquedaData, 
                busqueda: false
            });
        }
    }

    useEffect(() => {
        if(busqueda.busqueda){
            setNuevoModal(true);

            setBusquedaData({
                ...busquedaData, 
                ...busqueda
            });
        }        
    }, [busqueda]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_asesorias_cita.length; i++) {
            if(!options.some(option => option.value == listado_asesorias_cita[i].joven._id)){
                options.push({ value: listado_asesorias_cita[i].joven._id, label: [listado_asesorias_cita[i].joven.nombre, listado_asesorias_cita[i].joven.apellido_paterno, listado_asesorias_cita[i].joven.apellido_materno].join(' ') });
            }
        }

        setJovenesFilter(options);
    }, [listado_asesorias_cita]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_asesores.length; i++) {
            options.push({ value: listado_asesores[i]._id, label: [listado_asesores[i].nombre, listado_asesores[i].apellido_paterno, listado_asesores[i].apellido_materno].join(' ') });
        }

        setAsesoresFilter(options);
    }, [listado_asesores]);

    return (
        <Modal show={nuevoModal} size="lg" backdrop="static" centered onEntered={() => handleAbrir()} onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Filtros de búsqueda</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="fecha_inicio"
                                    name="fecha_inicio"
                                    className="form-control text-center input-datepícker"
                                    dateFormat="dd/MM/yyyy"
                                    locale="es-ES"
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selected={ busquedaData.fecha_inicio != null ? new Date(busquedaData.fecha_inicio) : '' }
                                    onChange={ date => handleDatePicker('fecha_inicio', date) }
                                />
                                <label className="label-datepicker" htmlFor="fecha_inicio">Fecha inicial de próxima cita</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="fecha_fin"
                                    name="fecha_fin"
                                    className="form-control text-center input-datepícker"
                                    dateFormat="dd/MM/yyyy"
                                    locale="es-ES"
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selected={ busquedaData.fecha_fin != null ? new Date(busquedaData.fecha_fin) : '' }
                                    onChange={ date => handleDatePicker('fecha_fin', date) }
                                />
                                <label className="label-datepicker" htmlFor="fecha_fin">Fecha final de próxima cita</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="mensajes"
                                name="mensajes"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Seleccionar mensajes"
                                isClearable
                                options={mensajesFilter}
                                value={mensajesData}
                                onChange={(value) => handleSelectMensajes(value)}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </div>
                    </div>

                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="id_joven"
                                name="id_joven"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Seleccionar joven"
                                isClearable
                                options={jovenesFilter}
                                value={jovenData}
                                onChange={(value) => handleSelectJoven(value)}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </div>
                    </div>

                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="id_asesor"
                                name="id_asesor"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Seleccionar asesor"
                                isClearable
                                options={asesoresFilter}
                                value={asesorData}
                                onChange={(value) => handleSelectAsesor(value)}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </div>
                    </div>

                    <div className="col-md-12 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="status"
                                name="status"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Seleccionar status"
                                isClearable 
                                isMulti={true} 
                                options={statusFilter}
                                value={statusData}
                                onChange={(value) => handleSelectStatus(value)}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </div>
                    </div>
                </div>                  
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Buscar</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-magnifying-glass fa-sm"></i> Buscar</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default FiltrosAsesorias;